import React from "react";
import GenericAvatar from "../dashboard/AIInbox/GenericAvatar";
import MessageContent from "./MessageContent";

const ReceiverMessage = ({ message, thread }) => {
  const customerAva = thread?.customer?.picture_url;

  const firstName = thread?.customer?.first_name;
  const lastName = thread?.customer?.last_name;

  return (
    <div className="flex items-start gap-2">
      <div>
        {customerAva ? (
          <img
            src={customerAva}
            alt="Receiver"
            className="object-cover size-10 rounded-full min-w-10"
          />
        ) : (
          <GenericAvatar firstName={firstName} lastName={lastName} />
        )}
      </div>
      <div className="flex flex-col gap-2">
        <p className="m-0 p-0 text-sm font-medium leading-tight text-slate-700">
          {firstName} {lastName}
        </p>

        <div className="p-3 rounded-lg rounded-tl-none outline outline-1 outline-offset-[-1px] outline-zinc-100 bg-gray-50">
          <MessageContent message={message} />
        </div>

        <p className="m-0 p-0 text-zinc-600 text-xs font-normal leading-none">
          {message.sentTime}
        </p>
      </div>
    </div>
  );
};

export default ReceiverMessage;
